import * as ArticleTypes from 'Flow2/components/Article/ArticleTypes/ArticleTypes';
import SearchHelper from 'Flow2/components/Article/Helpers/SearchHelper';

class SortHelper {

    sortByValue = ({ data, sorted, field, childObj, isNumber, isFloat = false }) => {
        let sortedData = [];
        if (data && data.length) {
            let order = (sorted && sorted === ArticleTypes.DESC) ? -1 : 1;
            sortedData = data.sort((a, b) => {
                let aSort = childObj ? a[childObj][field] : a[field];
                let bSort = childObj ? b[childObj][field] : b[field];
                if (isNumber) {
                    if(isFloat) {
                        aSort = parseFloat(aSort) ? parseFloat(aSort) : aSort;
                        bSort = parseFloat(bSort) ? parseFloat(bSort) : bSort;
                    } else {
                        aSort = parseInt(aSort) ? parseInt(aSort) : aSort;
                        bSort = parseInt(bSort) ? parseInt(bSort) : bSort;
                    }
                } else {
                    aSort = typeof (aSort) == 'string' ? aSort.toLowerCase() : aSort;
                    bSort = typeof (bSort) == 'string' ? bSort.toLowerCase() : bSort;
                }

                if (aSort && bSort && (aSort > bSort)) return 1 * order;
                if (aSort && bSort && (aSort < bSort)) return -1 * order;
                return 0;
            })
        }
        return sortedData;
    }

    sortActions = ({ articleObjects, refreshObjects, objName, intlName, updateArticleObjects, formatMessage, searchReport, currentId }) => {
        let sorted, field;
        const { currentSortField, currentSortSorted, currentData } = articleObjects[objName];
        if (!currentSortField || !currentSortSorted) {
            sorted = ArticleTypes.DESC;
            field = ArticleTypes.DATE;
            refreshObjects({
                name: field, sorted,
                articleObjects,
                updateArticleObjects,
                formatMessage, objName, intlName
            })
        } else {
            sorted = currentSortSorted;
            field = currentSortField;
        }
        if (searchReport) return searchReport({ articleid: currentId, sortcrit: field, sortorder: sorted });

        return this.sortByValue({ data: currentData, sorted, field });
    }

    sortIconClick = ({ name, articleObjects, updateArticleObjects, formatMessage, objName, intlName, currentId, searchReport, currentData }) => {
        let sorted = '';
        let data = [];
        console.log("LAMTEST sortIconClick articleObjects", articleObjects);
        if (!articleObjects[objName].currentSortSorted
            || articleObjects[objName].currentSortSorted === ArticleTypes.DESC) sorted = ArticleTypes.ASC;
        else sorted = ArticleTypes.DESC;
        if (searchReport) searchReport({ articleid: currentId, sortcrit: name, sortorder: sorted });
        else data = this.sortByValue({ data: currentData, sorted, field: name });
        SearchHelper.refreshObjects({
            name, sorted, articleObjects,
            updateArticleObjects, formatMessage, objName, intlName
        });

        return data;
    }

}

export default SortHelper = new SortHelper();
